<template>
    <div class="paddingSpace">
      <b-container>
        <b-row class="TitleArea">
            <b-col sm="12" lg="6">
                <h1 class="heading extraPad">Order of Merit</h1>
            </b-col>
            <b-col  sm="12" lg="6" class="above769">
              <div>
                <b-dropdown id="dropdown-1" :text="title" class="m-md-2">
                  <b-dropdown-item value="T1" title="Tier 1 Order of Merit" v-on:click="pickStat">Tier 1 Order of Merit</b-dropdown-item>
                  <b-dropdown-item value="T2" title="Tier 2 Order of Merit" v-on:click="pickStat">Tier 2 Order of Merit</b-dropdown-item>
                  <b-dropdown-item value="AL" title="Amateur League Order of Merit" v-on:click="pickStat">Amateur League Order of Merit</b-dropdown-item>
                  <!-- <b-dropdown-item value="pam" title="Pro-Ams Order of Merit" v-on:click="pickStat">Pro-Ams Order Of Merit</b-dropdown-item> -->
                </b-dropdown>
              </div>
            </b-col>
        </b-row>
        <div v-if="noDataMessage" class="noOOM">
          <h2 class="noPresent">{{ noDataMessage }}</h2>
        </div>
        <div v-else>
          <Oom
              :config="config"
              :tm_params="tm_params"
              :data="oomData"
              :id="id"
          />
        </div>
      </b-container>
    </div>
</template>
<script>
import apiCall from "@/services/api.js";
import { Oom } from "@ocs-software/vue-ocs";
import axios from 'axios';
// import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
  name: "OOM Slider Homepage",
  props: ['config'],
  components: { 
    Oom 
  },
  data() {
    return {
      slides: 10,
      fields: [
        { key: "pos", label: "Pos" , class: "posnum"},
        { key: "name", label: "Name" },
        { key: "nationality", label: "Nat" },
        { key: "oom_value", label: "Points" },
        { key: "tournaments_played", label: "Tourns" }
      ],
      currentOom: [],
      previousOom: [],
      year: parseInt(this.Year) - 1,
      Year: '2026',
      flag: "flag",
      pPage:4,
      oomData: [],
      imageAlbumList: [],
      fullAlbumList: [],
      playerImages: [],
      title: 'Tier 1 Order of Merit',
      statTour: '',
      color:'',
      noDataMessage:""
    };
  },
  methods:{
    upDown(){
      if (this.pPage === 4)
      this.pPage = 10
      else if (this.pPage === 10)
      this.pPage = 4
    },
    pickStat: function(event) {
      var stat = event.target.getAttribute("title");
      this.title = stat;
      var tour = event.target.getAttribute("value");
      console.log('tour ' + tour)
      this.statTour = tour;
      console.log('this.statTour ' + this.statTour)
      this.colourStat(tour);
      let cacheTour = ""

      if (tour == 'T1') {
        cacheTour = 'cpt'
      } else if (tour == 'T2') {
        cacheTour = 'cp2'
      } else if (tour == 'AL') {
        cacheTour = 'cp3'
      }
      axios
        .get(
          "https://api.euro.ocs-software.com/cpt/cache/" +
            cacheTour +
            "/" +
            this.Year +
            "/" +
            this.Year +
            "-ooms-oom-" +
            tour +
            ".json?randomadd=" +
            new Date().getTime()
        )
       .then(async (response) => {
          this.oomData = response.data;

          if (!this.oomData || Object.keys(this.oomData).length === 0) {
            this.noDataMessage = "No data available";

            return axios.get(
              "https://api.euro.ocs-software.com/cpt/cache/" +
                cacheTour +
                "/" +
                this.year + // ⚠️ check case here
                "/" +
                this.year +
                "-ooms-oom-" +
                tour +
                ".json?randomadd=" +
                new Date().getTime()
            );
          } else {
            
            this.slides = response.data.oom.oom_entry.slice(0, 10);

            await Promise.all(this.slides.map(async (player) => {
              try {
                const albumRes = await axios.get(
                  'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                  encodeURIComponent(
                    btoa(
                      'https://api.smugmug.com/api/v2/folder/user/andycrook/Clutch-Pro-Tour/Profile/Scorecards/' +
                      player.playerno +
                      '!albumlist?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                    )
                  )
                );

                const albums = albumRes.data.Response.AlbumList || [];

                let images = [];

                for (const album of albums) {
                  const imgRes = await axios.get(
                    'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                    encodeURIComponent(
                      btoa(
                        'https://api.smugmug.com' +
                        album.Uri +
                        '!images?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                      )
                    )
                  );

                  const albumImages = imgRes.data.Response.AlbumImage || [];

                  albumImages.forEach(img => {
                    images.push({
                      smug_thumbnail: img.ArchivedUri,
                      smug_web_url: img.WebUri
                    });
                  });
                }

                // Attach images to THIS player
                player.stat_rounds_played_images = images;

              } catch (err) {
                console.log(`Error for player ${player.playerno}`, err);
                player.stat_rounds_played_images = [];
              }
            }));

            this.noDataMessage = "";
          }
        })
        .then((fallbackResponse) => {
          if (fallbackResponse) {
            const data = fallbackResponse.data;

            if (data && Object.keys(data).length > 0) {
              this.slides = data.oom.oom_entry.slice(0, 10);
              localStorage.setItem("oom", JSON.stringify(this.slides));
              this.oomData = data;
              this.noDataMessage = "";
            }
          }
        })
        .catch((error) => {
          console.log("error in axios call", error);
          this.noDataMessage = "No Order of Mertit Data Available";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    colourStat: function(tour) {
      if (tour == 'T1') {
        this.color = 'color: #bceff0'
      } else if (tour == 'T2') {
        this.color = 'color: #bde9d8'
      } else if (tour == 'AL') {
        this.color = 'color: #dfc3c2'
      } else if (tour == 'pam') {
        this.color = 'color: #fff'
      } else if (tour == 'qsc') {
        this.color = 'color: #ededc3'
      }
    },
  },
  computed:{
    ooms:function (){
      if (this.currentOom !== null)
      return this.currentOom
      else return this.previousOom
    },
    // colourTour: function() {
    //   var color = '';
    //   if (this.statTour == 'cpt') {
    //     color = 'color: #bceff0'
    //   } else if (this.tournID == 'cp2') {
    //     color = 'color: #1FFFA5'
    //   } else if (this.tournID == 'cp3') {
    //     color = 'color: #dfc3c2'
    //   } else if (this.tournID == 'pam') {
    //     color = 'color: #fff'
    //   } else if (this.tournID == 'qsc') {
    //     color = 'color: #1FFFA5'
    //   }
    //   return color
    // },
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    }
  },
  async mounted() {
    try {
      // const stat = "-ooms-oom-" + process.env.VUE_APP_OOM;
      const stat = "-ooms-oom-" + 'T1';
      const tour = "cpt"

      let response = await apiCall.stat(this.Year, stat, tour);
      this.oomData = response.data;

      if (!this.oomData || Object.keys(this.oomData).length === 0) {
        // NO DATA CASE
        this.noDataMessage = "No Order of Mertit Data Available";

       
        let fallback = await apiCall.stat(this.year, stat, tour);

        if (fallback.data && Object.keys(fallback.data).length > 0) {
          this.slides = fallback.data.oom.oom_entry.slice(0, 10);
          localStorage.setItem("oom", JSON.stringify(this.slides));
          this.oomData = fallback.data;
          this.noDataMessage = "";
        }
      } else {
        //  NORMAL CASE
        this.slides = response.data.oom.oom_entry.slice(0, 10);
        localStorage.setItem("oom", JSON.stringify(this.slides));

        this.slides = response.data.oom.oom_entry.slice(0, 10);

        await Promise.all(this.slides.map(async (player) => {
          try {
            const albumRes = await axios.get(
              'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
              encodeURIComponent(
                btoa(
                  'https://api.smugmug.com/api/v2/folder/user/andycrook/Clutch-Pro-Tour/Profile/Scorecards/' +
                  player.playerno +
                  '!albumlist?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                )
              )
            );

            const albums = albumRes.data.Response.AlbumList || [];

            let images = [];

            for (const album of albums) {
              const imgRes = await axios.get(
                'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                encodeURIComponent(
                  btoa(
                    'https://api.smugmug.com' +
                    album.Uri +
                    '!images?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                  )
                )
              );

              const albumImages = imgRes.data.Response.AlbumImage || [];

              albumImages.forEach(img => {
                images.push({
                  smug_thumbnail: img.ArchivedUri,
                  smug_web_url: img.WebUri
                });
              });
            }

            // Attach images to THIS player
            player.stat_rounds_played_images = images;

          } catch (err) {
            console.log(`Error for player ${player.playerno}`, err);
            player.stat_rounds_played_images = [];
          }
        }));

      }

      this.loading = false;
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      this.noDataMessage = "No Order of Mertit Data Available";
    }
  }
};
</script>

<style scoped>
h2.noPresent {
  padding-bottom: 0 !important;
  text-align: center;
  padding-top: 2.4em;
  font-size: 32px !important;
  color: #081C3F;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
}
.noOOM {
  background-color: #F8F8F8;
  height: 200px;
}
span.posSlide {
  color: #00FFFE;
  font-size: 33px;
  font-weight: bold;
  position: relative;
  top: 22px;
  left: 22px;
}
.arrowbox {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/OoM_Triangle.png');
  background-repeat: no-repeat;
  height: 89px;
  position: relative;
  top: 162px;
}
::v-deep button#dropdown-1__BV_toggle_ {
  width: 100%;
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 424px;
  height: 52px;
  border-radius: 26px;
}
::v-deep .dropdown-toggle::after {
  float: right;
  position: relative;
  top: 10px;
}
::v-deep .btn {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
::v-deep .btn-secondary {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  border-radius: 0px;
}
::v-deep .btn-secondary:hover {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:active {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 100%;
}
::v-deep .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 18px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
div#dropdown-1 {
  width: 424px;
  height: 52px;
  text-align: left;
  float: right;
  border-radius: 0px;
}
a.allNewsLink {
  text-decoration: none!important;
}
.mobFulRank {
  position: relative;
  top: -18px;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--prev {
  left: -5.5em;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--next {
  right: -5.5em;
}
.arrowSize {
  width: 80px;
}
img.arrowSize.leftArrow {
}
img.arrowSize.rightArrow {
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--prev, .vueperslides__arrows--outside .vueperslides__arrow--next {
  left: auto;
  right: -4.5em!important;
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--next, .vueperslides__arrows--outside .vueperslides__arrow--prev {
  right: auto;
  left: -4.5em!important;
}
::v-deep .vueperslides__parallax-wrapper {
  padding-bottom: 45%!important;
}
::v-deep .carousel-3d-slide {
  border-radius: 6px!important;
}
a.playerProfile:hover {
  text-decoration: none;
}
::v-deep a.prev {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Left-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  left: -6px;
}
::v-deep a.next {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Right-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  right: -5px;
}
::v-deep a.next > span{
  display: none;
}
::v-deep a.prev > span{
  display: none;
}
.lineBreakLine {
  margin-top: 10px;
}
.oomSliderPad {
  padding-left: 40px;
  padding-right: 40px;
  background-color: #fff;
  height: 400px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
span.oomSliderDetails {
  color: #081C3F;
  font-size: 20px;
  font-weight: 600;
  float: right;
}
span.oomSliderTitle {
  color: #081C3F;
  font-size: 16px;
  font-weight: 600;
}
.posPosition {
  position: relative;
  top: 30px;
}
.posCenter {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 90px;
  margin: auto;
  /* background-color: #081C3F; */
  background: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Ellipse-3-2.png);
  background-repeat: no-repeat;
  height: 90px;
  border-radius: 50px;
  position: relative;
  top: -1.8em;
  background-size: contain;
}
.slideName {
  color: #081C3F;
  font-size: 30px;
  text-align: left;
  font-weight: bold;
  /* margin-top: -0.8em; */
  margin-top: -18px;
  margin-bottom: 30px;
}
.oomImage {
  background-repeat: no-repeat;
  background-size: cover;
  height: 250px;
  /* background-position: center; */
  background-position: center;
}
::v-deep .carousel-3d-container {
  height: 625px !important;
}
::v-deep .carousel-3d-slide {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  top: 0;
  border-radius: 50px;
  /* border-color: #000; */
  /* border-color: rgba(0, 0, 0, .4); */
  border-style: solid;
  background-size: cover;
  background-color: #fff;
  display: block;
  margin: 0;
  box-sizing: border-box;
  text-align: left;
  height: 625px !important;
  border: 1px solid #e9e9e9;
}
.TitleArea {
  padding-bottom: 30px;
}
.paddingSpace {
  padding: 50px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #081C3F;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
::v-deep tbody {
  font-size: 1rem;
}
a {
  color: #337ab7!important;
  background-color: transparent;
  font-weight: 500;
}
a:hover{
  text-decoration: underline;
}

.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
::v-deep tr:nth-child(odd) {
  background-color: #E8E8E8;
}
::v-deep tr:nth-child(odd) {
  background-color: #ffff;
}
.table{
      margin-bottom: 0;
}
.more{
  background-color: #dfe1e6;
  text-align: center;
}
.flex{
  display: inline-flex;
}
.moreBtn{
  color: #337ab7 !important;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #dfe1e6!important;
  border: none!important;
  box-shadow: none!important;
  padding: 0.375rem 0.175rem;
}
.fullList{
  width: auto!important;
}
.fullList>a{
  color: #337ab7 !important;
  font-size: 20px;
  font-weight: 400;
  text-decoration: none;
}
li {
  list-style: none;
}
.black{
  color: black;
  margin-left: -10px;
}
::v-deep .vueperslide {
  border: 1px solid #E0E0E0;
}

@media only screen and (max-width: 990px) {
  .carousel-3d-slide.current {
    width: 100%!important;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #081C3F;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #081C3F;
    display: block;
    margin: auto;
    margin-top: 30px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    transform: translateY(-10px);
  }
  .heading {
    /* font-weight: 600; */
    font-size: 36px;
    color: #081C3F;
    text-align: center;
    padding-top: 30px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
   .paddingSpace {
    padding: 15px;    
  }
  ::v-deep .carousel-3d-slider {
    width: auto!important;
  }
}
</style>
<style scoped src="@/css/oom.css"></style>
